import {
  Snowflake, ThermometerSnowflake, Thermometer, ThermometerSun, Flame
} from 'lucide-react';

export const SCORE_THRESHOLDS = { VERY_HIGH: 86, HIGH: 66, MEDIUM: 36, LOW: 16 };

export const TEMPERATURE_LEVELS = ['very_low', 'low', 'medium', 'high', 'very_high'];

export const TEMPERATURE_ICONS = {
  very_low: Snowflake,
  low: ThermometerSnowflake,
  medium: Thermometer,
  high: ThermometerSun,
  very_high: Flame
};

const BG_COLORS = {
  50: {
    veryHigh: 'tw-bg-red-50',
    high: 'tw-bg-orange-50',
    mid: 'tw-bg-yellow-50',
    low: 'tw-bg-cyan-50',
    veryLow: 'tw-bg-blue-50'
  },
  100: {
    veryHigh: 'tw-bg-red-100',
    high: 'tw-bg-orange-100',
    mid: 'tw-bg-yellow-100',
    low: 'tw-bg-cyan-100',
    veryLow: 'tw-bg-blue-100'
  }
};

const getScoreTier = (score) => {
  if (score >= SCORE_THRESHOLDS.VERY_HIGH) return 'veryHigh';
  if (score >= SCORE_THRESHOLDS.HIGH) return 'high';
  if (score >= SCORE_THRESHOLDS.MEDIUM) return 'mid';
  if (score >= SCORE_THRESHOLDS.LOW) return 'low';
  return 'veryLow';
};

const TEXT_COLORS = {
  veryHigh: 'tw-text-red-600',
  high: 'tw-text-orange-600',
  mid: 'tw-text-yellow-600',
  low: 'tw-text-cyan-600',
  veryLow: 'tw-text-blue-600'
};

const BAR_COLORS = {
  veryHigh: 'tw-bg-red-500',
  high: 'tw-bg-orange-500',
  mid: 'tw-bg-yellow-500',
  low: 'tw-bg-cyan-500',
  veryLow: 'tw-bg-blue-500'
};

export const getScoreColor = (score) => TEXT_COLORS[getScoreTier(score)];

export const getScoreBgColor = (score, shade) => {
  const tier = BG_COLORS[shade] || BG_COLORS[50];
  return tier[getScoreTier(score)];
};

export const getScoreBarColor = (score) => BAR_COLORS[getScoreTier(score)];

export const getTemperatureKey = (level) => {
  switch (level) {
    case 'very_high': return 'copilot_ventas.very_hot';
    case 'high': return 'copilot_ventas.hot';
    case 'medium': return 'copilot_ventas.warm';
    case 'low': return 'copilot_ventas.cool';
    case 'very_low': return 'copilot_ventas.cold';
    default: return null;
  }
};

export const getTemperatureLevelFromScore = (score) => {
  if (score >= SCORE_THRESHOLDS.VERY_HIGH) return 'very_high';
  if (score >= SCORE_THRESHOLDS.HIGH) return 'high';
  if (score >= SCORE_THRESHOLDS.MEDIUM) return 'medium';
  if (score >= SCORE_THRESHOLDS.LOW) return 'low';
  return 'very_low';
};
